"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnCollateralAction = void 0;
const constant_1 = require("../../constant");
const depositMining_1 = require("./util/depositMining");
const refreshReserve_1 = require("./util/refreshReserve");
const withdrawObligationCollateral_1 = require("./util/withdrawObligationCollateral");
const larixInstructionCollector_1 = require("../../utils/larixInstructionCollector");
const baseAction_1 = require("./util/baseAction");
const account_1 = require("../../utils/account");
class UnCollateralAction extends baseAction_1.BaseAction {
    unCollateral(reserveData, larixMining, larixObligation) {
        return __awaiter(this, void 0, void 0, function* () {
            let obligation = larixObligation === null || larixObligation === void 0 ? void 0 : larixObligation.state;
            if (obligation == undefined) {
                throw new Error("Invalid obligation");
            }
            let mining = larixMining === null || larixMining === void 0 ? void 0 : larixMining.state;
            if (mining == undefined) {
                throw new Error("Invalid mining account");
            }
            const detailReserve = reserveData.state;
            const lendingMarket = this.marketConfig.marketId;
            const connection = this.userInfo.connection;
            const lendingProgramID = this.marketConfig.programId;
            const larixTransaction = new larixInstructionCollector_1.LarixInstructionCollector(this.wallet);
            const destinationCollateral = this.userInfo.getCollateralTokenAccount(reserveData);
            if (destinationCollateral == undefined) {
                throw new Error("Invalid collateral token account");
            }
            if (mining === undefined) {
                const myMinings = yield this.userInfo.getMiningOfMarket(lendingMarket, lendingProgramID);
                if (myMinings.length > 0) {
                    mining = myMinings[0];
                }
            }
            if (obligation === undefined) {
                const myObligations = yield this.userInfo.getObligationOfMarket(lendingMarket, lendingProgramID);
                if (myObligations.length > 0) {
                    obligation = myObligations[0];
                }
            }
            let destinationCollateralAddress;
            if (obligation == undefined) {
                destinationCollateralAddress = yield (0, account_1.getOrCreateAssociatedTokenAccount)(connection, larixTransaction.instructions, this.userInfo.publicKey, detailReserve.info.collateral.mintPubkey, this.userInfo.publicKey);
                larixTransaction.newTransaction();
            }
            else {
                destinationCollateralAddress = destinationCollateral.pubkey;
            }
            yield (0, withdrawObligationCollateral_1.withdrawObligationCollateral)(this.connection, this.marketConfig, larixTransaction.signers, larixTransaction.instructions, larixTransaction.cleanupInstructions, obligation, constant_1.U64_MAX, destinationCollateralAddress, detailReserve, this.userInfo.publicKey, this.marketData.reserveStates, lendingProgramID, this.marketConfig.authorityId);
            if (obligation.info.deposits.length + obligation.info.borrows.length >= 4) {
                larixTransaction.newTransaction();
            }
            yield (0, refreshReserve_1.refreshReserve)(this.connection, this.marketConfig, larixTransaction.signers, larixTransaction.instructions, larixTransaction.cleanupInstructions, detailReserve, lendingProgramID);
            yield (0, depositMining_1.depositMining)(connection, larixTransaction.signers, larixTransaction.instructions, larixTransaction.cleanupInstructions, destinationCollateralAddress, detailReserve, constant_1.U64_MAX, this.userInfo.publicKey, detailReserve.info.lendingMarket, mining.pubkey, lendingProgramID, this.marketConfig.authorityId);
            return larixTransaction;
        });
    }
}
exports.UnCollateralAction = UnCollateralAction;
